export default {
    title: '訂單確認'
}
